export const setConsentedApps = (consentedApps) => ({
    type: "SET_CONSENTED_APPS",
    payload: consentedApps,
  });